import { render, staticRenderFns } from "./problemDetail.vue?vue&type=template&id=68fdac16&scoped=true"
import script from "./problemDetail.vue?vue&type=script&lang=js"
export * from "./problemDetail.vue?vue&type=script&lang=js"
import style0 from "./problemDetail.vue?vue&type=style&index=0&id=68fdac16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fdac16",
  null
  
)

export default component.exports